'use client';

import React, { useState } from 'react';
import { Search, Bell, HelpCircle, Menu } from 'lucide-react';
import { useAppraisalStore } from '@/store/appraisalStore';

interface AppTopbarProps {
  breadcrumb?: { label: string; href?: string }[];
}

export default function AppTopbar({ breadcrumb }: AppTopbarProps) {
  const { setSidebarCollapsed, sidebarCollapsed } = useAppraisalStore();
  const [searchVal, setSearchVal] = useState('');

  return (
    <header className="pn-appraisal__topbar">
      <div className="pn-appraisal__topbar-left">
        {/* Mobile menu */}
        <button
          className="pn-appraisal__topbar-btn pn-appraisal__topbar-mobile-menu"
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          aria-label="Toggle menu"
        >
          <Menu size={16} />
        </button>

        {/* Breadcrumb */}
        {breadcrumb && (
          <nav className="pn-appraisal__topbar-breadcrumb" aria-label="Breadcrumb">
            <span>PNAppraisal</span>
            {breadcrumb.map((crumb, idx) => (
              <React.Fragment key={`crumb-${idx}`}>
                <span className="pn-appraisal__topbar-breadcrumb-sep">/</span>
                {idx === breadcrumb.length - 1 ? (
                  <span className="pn-appraisal__topbar-breadcrumb-current">{crumb.label}</span>
                ) : (
                  <span>{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
      </div>

      <div className="pn-appraisal__topbar-right">
        {/* Search */}
        <div className="pn-appraisal__topbar-search pn-appraisal__hide-mobile">
          <Search size={14} />
          <input
            type="text"
            placeholder="Search cycles, employees, templates…"
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            aria-label="Global search"
          />
        </div>

        <button className="pn-appraisal__topbar-btn" aria-label="Help">
          <HelpCircle size={16} />
        </button>

        <button className="pn-appraisal__topbar-btn pn-appraisal__topbar-btn--badge" aria-label="Notifications">
          <Bell size={16} />
        </button>
      </div>
    </header>
  );
}